<template>
  <v-menu
    offset-y
    left
    transition="slide-y-transition"
  >
    <template #activator="{ on }">
      <v-btn
        text
        :icon="$vuetify.breakpoint.smAndDown"
        v-on="on"
        :class="{'btn-40': $vuetify.breakpoint.smAndDown}"
      >
        <span
          v-show="$vuetify.breakpoint.mdAndUp && showLabel"
        >{{ currentLocale.label }}</span>
        <span
          v-show="$vuetify.breakpoint.smAndDown && showLabel"
          class="d-sm-inline d-md-none text-center text-h6"
        >{{ (currentLocale.code || '').toUpperCase() }}</span>
        <v-icon
          v-if="showArrow"
          right
          class="d-md-inline d-sm-none"
        >
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>

    <v-list
      dense
      nav
    >
      <v-list-item
        v-for="locale in availableLocales"
        :key="locale.code"
        @click="setLocale(locale.code)"
      >
        <v-list-item-title>{{ locale.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  components: {

  },
  props: {
    showArrow: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentLocale() {
      let existingLocale = localStorage.getItem("locale") || this.$i18n.locale;
      this.$i18n.locale = existingLocale;
      const temp = this.$i18n.locales.find((i) => i.code === this.$i18n.locale);
      this.$store.state.app.local=temp;
      return temp;
    },
    availableLocales () {
      return this.$i18n.locales.filter((i) => i.code !== this.$i18n.locale);
    }
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$vuetify.lang.current = locale;
      if (locale === "ar") {
        this.$vuetify.rtl = true;
      } else {
        this.$vuetify.rtl = false;
      }
      localStorage.setItem("locale", locale);
    }
  }
};
</script>
